<template>
	<a class="btn btn-link text-appearance align-self-center collapsed" @click="toggleSidebar()" :href="'#filter-collapse_' + uid" role="button" aria-expanded="false" :aria-controls="'filter-collapse_' + uid">
		<svg class="filter__toggle-icon" fill="currentColor">
			<use xlink:href="#filter-list" />
		</svg>
		<span class="filter__toggle-txt" :class="{'filter__toggle-txt--active': selectedFacets.length > 0 }">
		<span v-if="selectedFacets.length > 0" v-html="selectedFacets.length"></span>

		{{ $translate("HoferAntikschmuck::Template.filter") }}
	</span>
	</a>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";


	export default {
		props: {
			uid: String,
		},

		methods: {
			toggleSidebar(){
				if(document.body.classList.contains('filter-open')){
					document.body.classList.remove("filter-open")
				}
				else{
					document.body.classList.add("filter-open")
				}
			},
		},
		computed: {
			...mapState({
				selectedFacets: state => state.itemList.selectedFacets
			}),
		}
	}
</script>
